import './ShoppingCartBar.less';

export const prefix = 'bm-c-shopping-cart-bar';

export { default } from './ShoppingCartBar';
